import clarity from '@microsoft/clarity';

// Inicializar Microsoft Clarity
export const initClarity = () => {
  // Leer el ID de Clarity desde las variables de entorno
  const clarityProjectId = process.env.REACT_APP_CLARITY_ID || 'ubbuo5pj2r';
  
  if (clarityProjectId) {
    clarity.init(clarityProjectId);
    // Establecer consentimiento por defecto
    clarity.consent(true);
    console.log('Microsoft Clarity initialized with project ID:', clarityProjectId);
  } else {
    console.warn('Microsoft Clarity not initialized: Missing project ID');
  }
};

// Identificar usuario (opcional)
export const identifyUser = (userId, sessionId, pageId, customTags) => {
  if (clarity) {
    clarity.identify(userId, sessionId, pageId, customTags);
  }
};

// Establecer tags personalizados (opcional)
export const setTag = (key, value) => {
  if (clarity) {
    clarity.set(key, value);
  }
};

// Actualizar consentimiento (GDPR)
export const updateConsent = (hasConsent) => {
  if (clarity) {
    clarity.consent(hasConsent);
  }
};

export default clarity;
